import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import { privateHttpClient } from '../httpClient';
import { campaignsApiPath } from './apiPath';
import type { GetSeedingProposalDetailResponse } from './getSeedingProposalDetail.api';
import type { GetSeedingRecruitmentDetailResponse } from './getSeedingRecruitmentDetail.api';

/**
 * 통일 시딩 상세 — `campaignId` 만으로 모집/제안 상세를 조회한다.
 *
 * 진입 라우트가 type 을 모르는 경우("진행 중 캠페인" 혼합 리스트 등)에도 campaignId 로 진입 →
 * 통일 엔드포인트(`/v2/curator/campaign/seeding/{campaignId}`, SID-2659)를 호출하고 응답의
 * `campaign.campaignType`(RECRUITMENT|PROPOSAL)으로 모집/제안 kind 를 판별한다.
 * (participation 은 신청/수락 전 null 이라 분기 기준으로 쓸 수 없음 — campaignType 이 단일 진실.)
 */
export type SeedingCampaignDetailApiResult =
  | { kind: 'recruit'; response: GetSeedingRecruitmentDetailResponse }
  | { kind: 'propose'; response: GetSeedingProposalDetailResponse };

export const getSeedingCampaignDetail = async (
  campaignId: number,
): Promise<SeedingCampaignDetailApiResult> => {
  const response = await executeStandardRequest(async () =>
    privateHttpClient.get<GetSeedingRecruitmentDetailResponse>(
      urlJoin(campaignsApiPath.getSeedingRecruitmentDetail(campaignId)),
    ),
  );
  // 통일 응답을 campaign.campaignType 으로 분기. (모집 스키마 타입상 campaignType 이 좁혀져
  // 있어 느슨하게 읽는다.) participation.participationType 은 신청/수락 전 null 이라 기준 부적합.
  const campaignType = (response.data.campaign as { campaignType?: string } | null)?.campaignType;
  return campaignType === 'PROPOSAL'
    ? { kind: 'propose', response: response as unknown as GetSeedingProposalDetailResponse }
    : { kind: 'recruit', response };
};
